export const config = {
  scoring: {
    challenge: [20, 10, 5, 0], // this array represents number of attempts. E.g. 20 points for first attempt, 10 for second, 5 for third, 0 for all others
    questionnaire: [20, 10, 5],
    noHintsUsed: 100,
  }
}

export default config;